import { StandardProps } from "../componentMap";
import { ProductStatusBox } from "../ProductStatusBox/ProductStatusBox";

export const RetiredTopInfoBox = ({
  configProps,
  product,
}: Pick<StandardProps, "product" | "configProps">) => {
  return (
    <ProductStatusBox
      product={product}
      configProps={{
        statusMessage: "No longer available online",
        showPrice: false,
        ...configProps,
      }}
    />
  );
};
